// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Footer = styled.div({
  borderTop: "var(--ds-border, #ebedf0)".concat(" solid 2px"),
  paddingTop: "var(--ds-space-050, 4px)",
  paddingBottom: "var(--ds-space-050, 4px)",
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});